module.exports = __webpack_public_path__ + "img/5.4d56b520.svg";